module.exports = __webpack_public_path__ + "img/cb56b8f.jpg";